// extracted by mini-css-extract-plugin
module.exports = {"bestMatchLabel":"styles_bestMatchLabel__1vpyb"};